/**
 * /guide - the compact Lyrixsa AI reference guide.
 *
 * The visual, screenshot-driven product guide remains available separately at
 * /fullguide. This route preserves the original four-section accordion.
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Accordion, SectionHeading } from '../components/ui';
import { GUIDE_SECTIONS } from '../data/faq';
import { c } from '../styles/theme';
import { paths } from './paths';

export default function QuickGuide() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div>
      <SectionHeading
        as="h1"
        title="Lyrixsa AI Guide"
        subtitle="Everything you need to make the most of Lyrixsa AI"
        marginBottom={18}
      />
      <Accordion
        items={GUIDE_SECTIONS.map((section) => ({ title: section.title, body: section.body }))}
        openIndex={openIndex}
        onToggle={(index) => setOpenIndex(openIndex === index ? -1 : index)}
      />
      <Link
        to={paths.visualGuide}
        className="lyx-guide-visual-link"
        style={{
          display: 'inline-block',
          marginTop: 14,
          color: c.accent,
          fontSize: 12.5,
          fontWeight: 500,
        }}
      >
        Open full guide
      </Link>
    </div>
  );
}
